import { render, staticRenderFns } from "./TextBlockContainer.vue?vue&type=template&id=af137938&"
import script from "./TextBlockContainer.vue?vue&type=script&lang=js&"
export * from "./TextBlockContainer.vue?vue&type=script&lang=js&"
import style0 from "./TextBlockContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports